import React from 'react';
import { makeStyles } from '@material-ui/core';
import bs_addedbed from '../../../../../static/images/bs_addedbed.png';
import bs_airborne_precaution from '../../../../../static/images/bs_airborne_precaution.png';
import bs_basic_cleansing from '../../../../../static/images/bs_basic_cleansing.png';
import bs_contact_precaution from '../../../../../static/images/bs_contact_precaution.png';
import bs_daybed from '../../../../../static/images/bs_daybed.png';
import bs_discharge from '../../../../../static/images/bs_discharge.png';
import bs_droplet_precaution from '../../../../../static/images/bs_droplet_precaution.png';
import bs_maintence from '../../../../../static/images/bs_maintence.png';
import bs_neats from '../../../../../static/images/bs_neats.png';
import bs_pending_admission from '../../../../../static/images/bs_pending_admission.png';
import bs_resusltation from '../../../../../static/images/bs_resusltation.png';
import bs_terminal_disinfection from '../../../../../static/images/bs_terminal_disinfection.png';
import bs_attention from '../../../../../static/images/bs_attention.png';
import bs_reverse_Isolation from '../../../../../static/images/bs_reverse_Isolation.png';
import bs_covid from '../../../../../static/images/bs_covid.png';
import bs_life_saving_equipment from '../../../../../static/images/bs_life_saving_equipment.png';
import bs from '../../../bsApp';
import { classNames } from '../../../../../utils';
import bs_home_leave from '../../../../../static/images/bs_home_leave.png';
import bs_home_leave_overtime from '../../../../../static/images/bs_home_leave_overtime.png';
import bs_return_day_case from '../../../../../static/images/bs_return_day_case.png';
import bs_to from '../../../../../static/images/bs_to.png';
import bs_frozen from '../../../../../static/images/icon_Frozen.svg';
import bs_mdro_contact from '../../../../../static/images/bs_mdro_contact.png';
import bs_mdro_confirmed from '../../../../../static/images/bs_mdro_confirmed.png';
import bs_basic_cleansing_on_going from '../../../../../static/images/bs_basic_cleansing_on_going.png';
import bs_terminal_disinfection_on_going from '../../../../../static/images/bs_terminal_disinfection_on_going.png';
import { CmsAlertStandardIcon, ElderlyHomeIcon } from '../../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    width: '1.1rem',
    height: '1.1rem',
  },
  imgTop: {
    width: '1.063rem',
    height: '0.688rem',
  },
  imgTop_2: {
    width: '1.063rem',
    height: '0.688rem',
    transform: 'scale(1.1, 1.3)',
    objectFit: 'cover',
  },
  mdro: {
    width: '1.75rem',
    height: '1.25rem',
  },
  boxSize: ({ position }) => ({
    width: position === 'top' ? '1.063rem' : '1.1rem',
    height: position === 'top' ? '0.688rem' : '1.1rem',
  }),
  cms_alert: {
    width: '1.92rem',
    height: '1.57rem',
  },
}));

export default function RemaksIcon({ typeName, className, position }) {
  const classes = useStyles({ position });
  const imgs = {
    [bs.DAY_BED]: bs_daybed,
    [bs.ADDED_BED]: bs_addedbed,
    [bs.NEATS]: bs_neats,
    [bs.BASIC_CLEANSING]: bs_basic_cleansing,
    [bs.TERMINAL_DISINFECTION]: bs_terminal_disinfection,
    [bs.PENDING_ADMISSION]: bs_pending_admission,
    [bs.RESUSITATION]: bs_resusltation,
    [bs.MAINTANIENCE]: bs_maintence,
    [bs.AIRBORNE_PRECAUTION]: bs_airborne_precaution,
    [bs.DROPLET_PRECAUTION]: bs_droplet_precaution,
    [bs.CONTACT_PRECAUTION]: bs_contact_precaution,
    [bs.DISCHARGING]: bs_discharge,
    [bs.ATTENTION]: bs_attention,
    [bs.REVERSE_LSOLATION]: bs_reverse_Isolation,
    [bs.LIFE_SAVING_EQUIPMENT]: bs_life_saving_equipment,
    [bs.COVID_19]: bs_covid,
    [bs.HOME_LEAVE]: bs_home_leave,
    [bs.HOME_LEAVE_OVERTIME]: bs_home_leave_overtime,
    [bs.TO]: bs_to,
    [bs.RETURN_DAY_CASE]: bs_return_day_case,
    [bs.FROZEN]: bs_frozen,
    [bs.MDRO_CONTACT]: bs_mdro_contact,
    [bs.MDRO_CONFIRMED]: bs_mdro_confirmed,
    [bs.BASIC_CLEANSING_ONGOING]: bs_basic_cleansing_on_going,
    [bs.TERMINAL_DISINFECTION_ONGOING]: bs_terminal_disinfection_on_going,
  };

  const svgIcons = {
    [bs.ELDERLY_HOME]: ElderlyHomeIcon,
    [bs.CMS_ALERT]: CmsAlertStandardIcon,
  };

  const imgStyles = {
    [bs.DAY_BED]: classes.img,
    [bs.ADDED_BED]: classes.img,
    [bs.NEATS]: classes.img,
    [bs.BASIC_CLEANSING]: classes.img,
    [bs.TERMINAL_DISINFECTION]: classes.img,
    [bs.PENDING_ADMISSION]: classes.img,
    [bs.RESUSITATION]: classes.img,
    [bs.MAINTANIENCE]: classes.img,
    [bs.AIRBORNE_PRECAUTION]: classes.imgTop,
    [bs.DROPLET_PRECAUTION]: classes.imgTop,
    [bs.CONTACT_PRECAUTION]: classes.imgTop,
    [bs.DISCHARGING]: classes.img,
    [bs.ATTENTION]: classes.img,
    [bs.REVERSE_LSOLATION]: classes.imgTop_2,
    [bs.LIFE_SAVING_EQUIPMENT]: classes.img,
    [bs.COVID_19]: classes.img,
    [bs.HOME_LEAVE]: classes.img,
    [bs.HOME_LEAVE_OVERTIME]: classes.img,
    [bs.TO]: classes.img,
    [bs.RETURN_DAY_CASE]: classes.img,
    [bs.FROZEN]: classes.img,
    [bs.MDRO_CONTACT]: classes.mdro,
    [bs.MDRO_CONFIRMED]: classes.mdro,
    [bs.BASIC_CLEANSING_ONGOING]: classes.img,
    [bs.TERMINAL_DISINFECTION_ONGOING]: classes.img,
    [bs.CMS_ALERT]: classes.cms_alert,
    [bs.ELDERLY_HOME]: classes.img,
  };

  const SvgIcon = svgIcons[typeName];
  let iconContent = '';

  if (SvgIcon) {
    iconContent = <SvgIcon className={imgStyles[typeName]} />;
  } else if (imgs[typeName]) {
    iconContent = <img src={imgs[typeName]} className={imgStyles[typeName]} alt="" />;
  }

  return <div className={classNames(classes.root, classes.boxSize, className)}>{iconContent}</div>;
}
